export const ChatState = {
    Loading: 'loading',
    Landing: 'landing',
    Composing: 'composing',
    Active: 'active',
} as const;

export type ChatState = (typeof ChatState)[keyof typeof ChatState];
